type VditorCtor = typeof import('vditor').default;

let vditorModule: VditorCtor | null = null;
let loadPromise: Promise<VditorCtor> | null = null;

/**
 * 懒加载 Vditor，全局共享同一份模块实例，避免重复下载与解析。
 */
export function loadVditor(): Promise<VditorCtor> {
  if (vditorModule) {
    return Promise.resolve(vditorModule);
  }
  if (!loadPromise) {
    loadPromise = import('vditor').then((mod) => {
      vditorModule = mod.default;
      return vditorModule;
    });
  }
  return loadPromise;
}

/**
 * 在空闲时预加载 Vditor，缩短首次打开 Markdown 组件的等待时间。
 */
export function prefetchVditor() {
  const run = () => {
    void loadVditor();
  };
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(run);
  } else {
    setTimeout(run, 200);
  }
}
